// extracted by mini-css-extract-plugin
export var wrapper = "sectionNavigation-module--wrapper--Z1ecx";
export var link = "sectionNavigation-module--link--xmt-z";
export var linkText = "sectionNavigation-module--linkText--Qx-Tj";
export var circle = "sectionNavigation-module--circle--I0rvp";
export var circleActive = "sectionNavigation-module--circleActive---9biJ";
export var activeLink = "sectionNavigation-module--activeLink--kibxa";
export var slideUp = "sectionNavigation-module--slideUp--JIIn-";
export var slideUpLarge = "sectionNavigation-module--slideUpLarge--kc1iz";